<template>
  <el-dialog title="证书管理" center v-model="dialogVisible" width="70%">
    <div class="dialogBd">
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column sortable prop="app_name" label="App名称">
        </el-table-column>
        <el-table-column sortable prop="bundle_id" width="200" label="Bid">
          <template #default="scope">
            <div class="bundleInput">
              <template v-if="scope.row.edit">
                <el-input
                  v-model="scope.row.bundle_id"
                  placeholder="请输入bundle_id"
                  class="edit-input"
                  size="small"
                />
              </template>
              <span v-else>{{ scope.row.bundle_id }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable prop="operator" label="负责人">
          <template #default="scope">
            <div class="bundleInput">
              <template v-if="scope.row.edit">
                <el-input
                  v-model="scope.row.operator"
                  placeholder="请输入负责人"
                  class="edit-input"
                  size="small"
                />
              </template>
              <span v-else>{{ scope.row.operator }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="rel_expire_time"
          width="320"
          label="rel证书"
        >
          <template #default="scope">
            <div class="fl">
              <el-button
                class="el-button"
                size="small"
                :disabled="scope.row.dev_expire_time === '0001-01-01T00:00:00Z'"
                @click="handleDownload(scope.row, 'rel')"
                ><i class="iconfont icon-download"></i>下载</el-button
              >
            </div>
            <div class="fl paddingLeft">
              <p>
                创建时间：
                <span
                  v-if="scope.row.rel_update_time === '0001-01-01T00:00:00Z'"
                  style="color: red"
                  >失效</span
                >
                <span v-else>{{
                  formatDateTime(scope.row.rel_update_time)
                }}</span>
              </p>
              <p>
                剩余时间：
                <span
                  v-if="scope.row.rel_expire_time === '0001-01-01T00:00:00Z'"
                  style="color: red"
                  >失效</span
                >
                <span v-else
                  ><CountDown
                    :endTime="formatDateTime(scope.row.rel_expire_time)"
                /></span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="dev_expire_time"
          width="320"
          label="dev证书"
        >
          <template #default="scope">
            <div class="fl">
              <el-button
                class="el-button"
                size="small"
                :disabled="scope.row.dev_expire_time === '0001-01-01T00:00:00Z'"
                @click="handleDownload(scope.row, 'dev')"
                ><i class="iconfont icon-download"></i>下载</el-button
              >
            </div>
            <div class="fl paddingLeft">
              <p>
                创建时间：
                <span
                  v-if="scope.row.dev_update_time === '0001-01-01T00:00:00Z'"
                  style="color: red"
                  >失效</span
                >
                <span v-else>{{
                  formatDateTime(scope.row.dev_update_time)
                }}</span>
              </p>
              <p>
                剩余时间：
                <span
                  v-if="scope.row.dev_expire_time === '0001-01-01T00:00:00Z'"
                  style="color: red"
                  >失效</span
                >
                <span v-else
                  ><CountDown
                    :endTime="formatDateTime(scope.row.dev_expire_time)"
                /></span>
              </p>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
        width="150"
        label="操作">
        <template #default="scope">
            <el-button v-if="scope.row.edit" type="success" size="small" @click="confirmEdit(scope.row)">确定</el-button>
            <el-button v-if="scope.row.edit" type="info" size="small" @click="cancelEdit(scope.row)">取消</el-button>
            <el-button v-if="!scope.row.edit && scope.row.replace === false" type="success" size="small" @click="scope.row.edit=!scope.row.edit">生成</el-button> -->
        <!-- <el-button v-if="scope.row.replace && !scope.row.edit" type="success" size="small" @click="confirmUpdate(scope.row)">更新</el-button>
            <el-button v-if="scope.row.replace && !scope.row.edit" type="primary" size="small" @click="scope.row.edit=!scope.row.edit">编辑</el-button>
          </template>
      </el-table-column> -->
      </el-table>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, defineExpose } from "vue";
import { formatDateTime } from "@/Utils/UtilTools";
import { apiGetCertificate } from "@/Api/AppApi";
import CountDown from "@/Components/CountDown.vue";

defineExpose({ initData });

const dialogVisible = ref(false);
const tableData = ref([]);
const loading = ref(false);
async function initData(appid) {
  dialogVisible.value = true;
  loading.value = true;
  const res = await apiGetCertificate(appid);
  loading.value = false;
  if (res.code === 0) {
    tableData.value = res.data.map((v) => {
      v.downloadShow = v.bundle_id !== "";
      v.replace = true;
      v.edit = false;
      v.originalTitle = v.bundle_id;
      return v;
    });
  }
}

function handleDownload(row, type) {
  const data = {
    project: row.project_id,
    appid: row.app_id,
    cert_type: type,
    bundle_id: row.bundle_id,
  };
  window.location.href =
    "/api/certificate/download?project=" +
    data.project +
    "&appid=" +
    data.appid +
    "&cert_type=" +
    data.cert_type +
    "&bundle_id=" +
    data.bundle_id;
}
</script>

<style scoped>
.dialogBd {
  padding: 20px;
}
.bundleInput {
  position: relative;
}
.edit-input {
  width: 95%;
}
.cancel-btn {
  position: absolute;
  top: 10px;
  right: -8px;
}
.fl {
  float: left;
}
.paddingLeft {
  padding-left: 20px;
}
.paddingLeft p {
  margin: 0;
}
.el-button {
  margin-top: 6px;
}
</style>
